import { render, staticRenderFns } from "./NewSubjectFollowup.vue?vue&type=template&id=652ce403&"
import script from "./NewSubjectFollowup.vue?vue&type=script&lang=js&"
export * from "./NewSubjectFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports